"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var helpers_exports = {};
__export(helpers_exports, {
  countedLitterAttr: () => countedLitterAttr,
  customBooleanAttr: () => customBooleanAttr,
  polystyreneLitterAttr: () => polystyreneLitterAttr
});
module.exports = __toCommonJS(helpers_exports);
var import_topo_map = require("@cartographerio/topo-map");
function countedLitterAttr(attributeId, label, unit = "items") {
  return (0, import_topo_map.thresholdAttr)({
    attributeId,
    label,
    unit,
    buckets: [
      (0, import_topo_map.thresholdBucket)(0, import_topo_map.marker.quality(0.4)),
      (0, import_topo_map.thresholdBucket)(10, import_topo_map.marker.quality(0.3)),
      (0, import_topo_map.thresholdBucket)(30, import_topo_map.marker.quality(0.2)),
      (0, import_topo_map.thresholdBucket)(50, import_topo_map.marker.quality(0.1)),
      (0, import_topo_map.thresholdBucket)(100, import_topo_map.marker.quality(0))
    ]
  });
}
function polystyreneLitterAttr(attributeId, label) {
  return (0, import_topo_map.stringAttr)({
    attributeId,
    label,
    buckets: [
      (0, import_topo_map.lookupBucket)("50-100", import_topo_map.marker.quality(0), "50-100% cover"),
      (0, import_topo_map.lookupBucket)("20-49", import_topo_map.marker.quality(0.1), "20-49% cover"),
      (0, import_topo_map.lookupBucket)("10-19", import_topo_map.marker.quality(0.2), "10-19% cover"),
      (0, import_topo_map.lookupBucket)("5-9", import_topo_map.marker.quality(0.3), "5-9% cover"),
      (0, import_topo_map.lookupBucket)("0-4", import_topo_map.marker.quality(0.4), ">0-4% cover")
    ]
  });
}
function customBooleanAttr(attributeId, label, falseLabel, trueLabel) {
  return (0, import_topo_map.booleanAttr)({
    attributeId,
    label,
    buckets: [(0, import_topo_map.lookupBucket)(false, import_topo_map.marker.quality(0.2), falseLabel), (0, import_topo_map.lookupBucket)(true, import_topo_map.marker.quality(0.8), trueLabel)]
  });
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  countedLitterAttr,
  customBooleanAttr,
  polystyreneLitterAttr
});
//# sourceMappingURL=helpers.js.map
